const apiRoutes = {

  // BACKEND_URL: "http://127.0.0.1:8000/api/v1",
  OBJECTS: "/objects",
  DYNAMIC_DATA: "/dynamic-data",
  EDIT: "/edit",
  DELETE: "/delete",
  FIELDS: "/fields",
  APPLICATION: "/application",
  PARENT: "/parent",
  LOGIN: "/login",
  SIGNUP: "/signup",
  AUTH: "/auth",
  TABS: '/tabs',
  SALESFORCE_LOGIN_ROUTE: '/auth/login/salesforce',
  BOOKS: '/book',
  NOTIFICATION: '/notification',
  ORGANIZATION: '/organizations',
  PLANS: '/plan',
  SUBSCRIPTIONS: '/subscription',
  SUBSCRIPTIONS2: '/subscription2',
  PLANAPIKEY: '/plan-api-key',
  MODELS: '/model',
  ROLES: '/role',
  USERS: '/users',
  INVOICE: '/invoice',
  CARDS: '/cards',
  APIKEYS: '/apikey',
  PROCESSING: '/processing',
  AUDITLOGS: '/audit',
  PAYMENT: '/payment',
  TRANSACTION: '/transaction',
  ORG_TRANSACTION:'/transaction/org',
  COMPRESSION: "/compression",
  THRESHOLD: '/threshold',
  CUSTOMEMAIL: '/custom-email',
  DATA_TRAINING: '/data-training',
  DOCUMENT_MANAGER: '/document-manager',
  CUSTOM_TEMPLATE: '/template',
};

export default apiRoutes;